export const SCROLL_TYPE = {
    CONTINUOUS: 'continuous', // 连续滚动
    PAGE: 'page' // 翻页
};

export const SCROLL_DIRECT = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical'
};

export const CONTENT_MARGIN = {
    TWENTY: 10, // 视觉给出为 2 倍图，fego  editor 上 1rem 为 50(宽度375)，实际数值需除以2
    THIRTY: 15,
    FORTY: 20,
    FIFTY: 25,
    SIXTY: 30
};
